<template>
  <div class="section-title">
    <div class="section-title-text">{{ title }}</div>
  </div>
</template>

<script>
export default {
  name: 'SectionTitle',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
.section-title {
  position: relative;
  padding: 0 10px;
  font-size: 16px;
  line-height: 12px;
  font-weight: 500;
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  margin-bottom: 20px;
  &::before {
    display: block;
    position: absolute;
    left: 0;
    top: 50%;
    width: 4px;
    height: 15px;
    border-radius: 16px;
    transform: translateY(-50%);
    background: #333333;
    content: '';
  }
  &-text {
    position: relative;
    display: inline-block;
    color: var(--text-color);
  }
}
</style>
